<template>
  <div class="comCue-dialog">
    <el-dialog v-model="isShow" width="512" align-center :close-on-click-modal="false">
      <img class="delTip-img" src="@/assets/delTip.png" alt=""/>
        <span class="tip-text">{{ props.msg }}</span>
        <div class="tips-footer">
          <div class="footer-btn">
            <el-button type="primary" size="small" @click="submit">确认</el-button>
            <el-button size="small" @click="closeDialog">取消</el-button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, withDefaults, defineEmits, defineProps, defineExpose } from "vue";
import { ElDialog, ElButton } from "element-plus";
const emits = defineEmits(["submit", "close"]);

const props = withDefaults(defineProps<{ msg: string }>(), {
  msg: "请确认是否删除？"
});

const isShow = ref<boolean>(false);

const closeDialog = (): void => {
  isShow.value = false;
  emits("close");
};

const submit = (): void => {
  isShow.value = false;
  emits("submit");
};

defineExpose({ isShow });
</script>

<style lang="scss" scoped>
.comCue-dialog {
  :deep(.el-dialog) {
    border-radius: 8px;
    padding: 0;
    background: linear-gradient(180deg, #dfe5ff, 0%, #fff, 57%);
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        .el-icon {
          color: rgba(0, 0, 0, 0.6);
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
    .el-dialog__body {
      height: 100%;
      padding: 40px 20px 20px 110px;
      box-sizing: border-box;
      .delTip-img {
        position: absolute;
        top: 20px;
        left: 20px;
        width: 80px;
        height: 88px;
      }
      .tip-text {
        font-size: 18px;
        color: #000;

        font-weight: 600;
      }
      .tips-footer {
        margin-top: 15px;
        margin-right: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        box-sizing: border-box;
        .footer-btn {
          display: flex;
          align-items: center;
          .el-button {
            padding: 12px 20px;
          }
          .cancel-text {
            margin: 0 25px 0 35px;
            font-size: 14px;
            color: #545e75;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
